'use client';

import { CheckCircle2, Info, Loader2, TriangleAlert, XCircle } from 'lucide-react';
import { Toaster as Sonner, ToasterProps } from 'sonner';

/**
 * Toaster premium : carte blanche arrondie à ombre douce, icône colorée par
 * type, fin accent coloré à gauche et bouton de fermeture soigné. Position
 * bas-droite. Les classes utilisent l'important suffixe (Tailwind v4) pour
 * l'emporter sur les styles de base de sonner.
 */
const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    theme="light"
    position="bottom-right"
    closeButton
    gap={10}
    offset={20}
    className="toaster group"
    icons={{
      success: <CheckCircle2 className="size-5 text-emerald-500" />,
      error: <XCircle className="size-5 text-rose-500" />,
      warning: <TriangleAlert className="size-5 text-amber-500" />,
      info: <Info className="text-primary-500 size-5" />,
      loading: <Loader2 className="size-5 animate-spin text-slate-400" />,
    }}
    toastOptions={{
      classNames: {
        toast:
          'group items-start! gap-3! rounded-2xl! border! border-slate-200/70! bg-white/95! p-4! shadow-[0_18px_50px_-12px_rgba(6,78,59,0.24)]! backdrop-blur-xl',
        title: 'text-sm! font-semibold! text-slate-900!',
        description: 'text-[13px]! leading-relaxed! text-slate-500!',
        icon: 'mt-0.5! shrink-0!',
        closeButton:
          'rounded-lg! border! border-slate-200! bg-white! text-slate-400! transition-colors hover:border-slate-300! hover:text-slate-600!',
        actionButton:
          'from-primary-500! to-primary-700! rounded-lg! bg-gradient-to-r! font-semibold! text-white!',
        cancelButton: 'rounded-lg! bg-slate-100! font-medium! text-slate-600!',
        success: 'border-l-[3px]! border-l-emerald-500!',
        error: 'border-l-[3px]! border-l-rose-500!',
        warning: 'border-l-[3px]! border-l-amber-500!',
        info: 'border-l-primary-500! border-l-[3px]!',
        loading: 'border-l-[3px]! border-l-slate-300!',
      },
    }}
    {...props}
  />
);

export { Toaster };
